import React from 'react';
import { Container, Grid, makeStyles, Typography, Link, Box, Hidden } from '@material-ui/core';

import Logo from '../../assets/images/logo.inline.svg';

import FacebookIcon from '../../assets/icons/facebook.inline.svg';
import InstagramIcon from '../../assets/icons/instagram.inline.svg';
import TwitterIcon from '../../assets/icons/twitter.inline.svg';
import LinkedinIcon from '../../assets/icons/linkedin.inline.svg';

import DownloadButton from '../../components/downloadButton';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(9, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5, 0),
    },
  },

  linksContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  buttonWrapper: {
    textAlign: 'right',
  },

  container: {
    padding: theme.spacing(9, 0, 3),
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(5, 0),
      flexDirection: 'column',
    },
  },

  socialsContainer: {
    flexGrow: 1,
    textAlign: 'right',
    '& > *': {
      paddingRight: 10,
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
      paddingTop: 50,
    },
  },
}));

export default function Footer() {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} md="auto">
            <Logo />
          </Grid>
          <Grid item xs={12} md="auto">
            <Box maxWidth={196}>
              <Typography>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
                labore et dolore magna aliquyam erat, sed
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md="auto">
            <div className={classes.linksContainer}>
              <Link href="#" color="textPrimary">
                Security
              </Link>
              <Link href="#" color="textPrimary">
                Privacy Policy
              </Link>
              <Link href="#" color="textPrimary">
                Terms of Use
              </Link>
              <Link href="#" color="textPrimary">
                Service Agreement
              </Link>
              <Link href="#" color="textPrimary">
                Supplier Agreement
              </Link>
              <Link href="#" color="textPrimary">
                Reseller Agreement
              </Link>
            </div>
          </Grid>
          <Hidden smDown>
            <Grid item md>
              <div className={classes.buttonWrapper}>
                <DownloadButton />
              </div>
            </Grid>
          </Hidden>
        </Grid>
        <div className={classes.container}>
          <Typography>© Copyright FamGuru 2021</Typography>
          <div className={classes.socialsContainer}>
            <Link href="#">
              <FacebookIcon />
            </Link>
            <Link href="#">
              <InstagramIcon />
            </Link>
            <Link href="#">
              <TwitterIcon />
            </Link>
            <Link href="#">
              <LinkedinIcon />
            </Link>
          </div>
        </div>
      </Container>
    </section>
  );
}
